import { t } from '@/plugins/i18n'
import { nextTick, ref } from 'vue'
import { useStore } from 'vuex'
import {
  amazonGet
} from '@/apis/inShipping'
import { ElMessage } from 'element-plus'

export default (form: any, formRef:any) => {
  const store = useStore()
  const getProductSkuList = async (val: never[]) => {
    console.log('getProductSkuList', val)
    console.log('val', val)
    const list = (val || []).map((e: any) => ({ ...e, deliveryNums: e.deliverNum ?? (form.allIncludeFlag === 1 ? e.allIncludeUseable : e.useable) }))
    const amazonSkuList = [...new Set(list.filter(v => v.amazonMsku).map(v => v.amazonMsku))]
    if (amazonSkuList.length) {
      const { data } = await amazonGet({
        amazonSkuList,
        customerShopId: store.getters.curShop
      })
      list.forEach((item, index) => {
        const findItem = data.find((v:any) => (v.amazonMsku === item.amazonMsku) && item.amazonMsku)
        if (findItem) {
          list[index] = {
            ...item,
            prepCategory: findItem.prepCategory,
            isValid: findItem.isValid,
            prepOwnerConstraint: findItem.prepOwnerConstraint,
            labelOwnerConstraint: findItem.labelOwnerConstraint
          }
        }
      })
    }
    const finalList = [...form.replenishPlanItemList]
    list.forEach((item: any) => {
      const findItem = finalList.find((v: any) => v.productSku === item.productSku)
      if (findItem) {
        findItem.deliveryNums = item.deliveryNums
      } else {
        finalList.push(item)
      }
    })
    form.replenishPlanItemList = finalList
    nextTick(() => {
      // 重新校验 form.deliverTaskDetails 里的 deliveryNums
      if (formRef.value) {
        // 遍历 deliverTaskDetails 中的每个元素进行验证
        form.replenishPlanItemList.forEach((_:any, index:number) => {
          formRef.value.validateField(`replenishPlanItemList.${index}.deliveryNums`, (errors: any) => {
            if (errors) {
              // 处理校验错误
              console.log('校验出错:', errors)
            } else {
              console.log('校验通过')
            }
          })
        })
      }
    })
  }

  const addProductVisible = ref(false)
  const openAddProductVisible = () => {
    addProductVisible.value = true
  }

  const STableRef = ref()

  const productSelection = ref([])
  const handleSelection = (val: any) => {
    productSelection.value = val
  }

  const delMoreRow = () => {
    productSelection.value.forEach((p: any) => {
      const idx = form.replenishPlanItemList.findIndex((e: any) => e.productSku === p.productSku)
      form.replenishPlanItemList.splice(idx, 1)
    })
    STableRef.value.clearSelection()
  }
  const delRow = (productSku: any) => {
    const idx = form.replenishPlanItemList.findIndex((e: any) => e.productSku === productSku)
    form.replenishPlanItemList.splice(idx, 1)
    STableRef.value.clearSelection()
  }

  return {
    STableRef,
    getProductSkuList,
    addProductVisible,
    openAddProductVisible,
    handleSelection,
    delMoreRow,
    delRow
  }
}
